import { ReactNode } from "react"
import {
  Block,
  Button,
  CheckCircle,
  HeadingSmall,
  ModalBody,
  ModalBodyWithImageProps,
  ModalFooter,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

type SuccessfulActionModalBodyProps = {
  title: ReactNode
  description: ReactNode
  footer?: ReactNode
  onClickContinue?: () => void
  nextStepButtonLabel?: string
  style?: ModalBodyWithImageProps["$style"]
}

export default function SuccessfulActionModalBody({
  title,
  description,
  footer,
  nextStepButtonLabel = "Claim rewards",
  onClickContinue,
  style = {},
}: SuccessfulActionModalBodyProps) {
  const [css, theme] = useStyletron()

  return (
    <>
      <ModalBody
        className={css({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "auto",
          marginTop: "auto",
          padding: theme.sizing.scale700,
          overflow: "hidden",
          height: "100%",
          ...style,
        })}
      >
        {typeof title === "string" ? (
          <>
            {/* TODO: Improve the `CheckCircle` in Clay lib to change border, checkmark and background colors */}
            <Block
              className={css({
                width: "62px",
                height: "62px",
                backgroundColor: theme.colors.green200,
                padding: "1px",
                borderRadius: "30px",
              })}
            >
              <CheckCircle
                size="60px"
                color={theme.colors.backgroundAlwaysDark}
              />
            </Block>
            <HeadingSmall
              marginTop={theme.sizing.scale800}
              className={css({
                textAlign: "center",
              })}
            >
              {title}
            </HeadingSmall>
          </>
        ) : (
          title
        )}

        {typeof description === "string" ? (
          <ParagraphLarge
            color={theme.colors.contentSecondary}
            marginTop={theme.sizing.scale300}
            style={{ textAlign: "center" }}
          >
            {description}
          </ParagraphLarge>
        ) : (
          description
        )}
      </ModalBody>
      <ModalFooter>
        {typeof footer === "undefined" ? (
          <Button width="100%" size="large" onClick={onClickContinue}>
            {nextStepButtonLabel}
          </Button>
        ) : (
          footer
        )}
      </ModalFooter>
    </>
  )
}
